<template>
    <div class="manage--content">
        <!-- Chinese -->
        <div v-if="typeLanguage == 1">
            <!-- PC -->
            <usingPcZh v-if="type == 0"></usingPcZh>

            <!-- PWA -->
            <pwaManualZh v-if="type == 1"></pwaManualZh>

            <!-- Change Language -->
            <changeLanguageManualZh v-else-if="type == 2"></changeLanguageManualZh>

            <!-- Login -->
            <loginManualZh v-else-if="type == 3"></loginManualZh>

            <!-- Forgot Pass -->
            <forgotPassManualZh v-else-if="type == 4"></forgotPassManualZh>

            <!-- Logout -->
            <logoutZh v-else-if="type == 5"></logoutZh>

            <!-- Search Course -->
            <searchCourseManualZh v-else-if="type == 6"></searchCourseManualZh>

            <!-- My Course -->
            <myCourseManualZh v-else-if="type == 7"></myCourseManualZh>

            <!-- content lesson -->
            <lessonContentZh v-else-if="type == 8 && loadDataLessonContent" :data="data.data"></lessonContentZh>

            <!-- Mid Term -->
            <midTermManualZh v-else-if="type == 9"></midTermManualZh>

            <!-- Final Exam -->
            <finalExamManualZh v-else-if="type == 10"></finalExamManualZh>

            <!-- Achievement -->
            <achievementManualZh v-else-if="type == 11"></achievementManualZh>

            <!-- Covenant -->
            <covenantManualZh v-else-if="type == 12"></covenantManualZh>

            <!-- Survey -->
            <surveyManualZh v-else-if="type == 13"></surveyManualZh>

            <!-- Export Note -->
            <exportNoteManualZh v-else-if="type == 14"></exportNoteManualZh>

            <!-- End Course -->
            <endCourseManualZh v-else-if="type == 15"></endCourseManualZh>

            <!-- study Situation List -->
            <studySituationListZh v-else-if="type == 16"></studySituationListZh>

            <!-- course Score Statistics -->
            <scoreStatisticsZh v-else-if="type == 17"></scoreStatisticsZh>

            <!-- search live course -->
            <searchLiveCourseZh v-else-if="type == 18"></searchLiveCourseZh>

            <!-- jonh live course -->
            <jonhLiveCourseZh v-else-if="type == 19"></jonhLiveCourseZh>

            <!-- Change Avatar -->
            <changeAvaManualZh v-else-if="type == 20"></changeAvaManualZh>

            <!-- Change Infor -->
            <changeInfoManualZh v-else-if="type == 21"></changeInfoManualZh>

            <!-- Change language system -->
            <changeLanguageSystemZh v-else-if="type == 22"></changeLanguageSystemZh>

            <!-- Change Pass -->
            <changePassManualZh v-else-if="type == 23"></changePassManualZh>

            <!-- Achievement Student -->
            <achievementStudentManualZh v-else-if="type == 24"></achievementStudentManualZh>

            <!-- Manage Student -->
            <manageStudentManualZh v-else-if="type == 25"></manageStudentManualZh>

            <!-- Manage Course -->
            <manageCourseManualZh v-else-if="type == 26"></manageCourseManualZh>

            <!-- Manage Attendance -->
            <manageAttendanceManualZh v-else-if="type == 27"></manageAttendanceManualZh>

            <!-- Manage Live Course -->
            <manageLiveCourseManualZh v-else-if="type == 28"></manageLiveCourseManualZh>
        </div>
        <!-- English -->
        <div v-else-if="typeLanguage == 2">
            <!-- PC -->
            <usingPcEn v-if="type == 0"></usingPcEn>

            <!-- PWA -->
            <pwaManualEn v-if="type == 1"></pwaManualEn>

            <!-- Change Language -->
            <changeLanguageManualEn v-else-if="type == 2"></changeLanguageManualEn>

            <!-- Login -->
            <loginManualEn v-else-if="type == 3"></loginManualEn>

            <!-- Forgot Pass -->
            <forgotPassManualEn v-else-if="type == 4"></forgotPassManualEn>

            <!-- Logout -->
            <logoutEn v-else-if="type == 5"></logoutEn>

            <!-- Search Course -->
            <searchCourseManualEn v-else-if="type == 6"></searchCourseManualEn>

            <!-- My Course -->
            <myCourseManualEn v-else-if="type == 7"></myCourseManualEn>

            <!-- content lesson -->
            <lessonContentEn v-else-if="type == 8 && loadDataLessonContent" :data="data.data"></lessonContentEn>

            <!-- Mid Term -->
            <midTermManualEn v-else-if="type == 9"></midTermManualEn>

            <!-- Final Exam -->
            <finalExamManualEn v-else-if="type == 10"></finalExamManualEn>

            <!-- Achievement -->
            <achievementManualEn v-else-if="type == 11"></achievementManualEn>

            <!-- Covenant -->
            <covenantManualEn v-else-if="type == 12"></covenantManualEn>

            <!-- Survey -->
            <surveyManualEn v-else-if="type == 13"></surveyManualEn>

            <!-- Export Note -->
            <exportNoteManualEn v-else-if="type == 14"></exportNoteManualEn>

            <!-- End Course -->
            <endCourseManualEn v-else-if="type == 15"></endCourseManualEn>

            <!-- study Situation List -->
            <studySituationListEn v-else-if="type == 16"></studySituationListEn>

            <!-- course Score Statistics -->
            <scoreStatisticsEn v-else-if="type == 17"></scoreStatisticsEn>

            <!-- search live course -->
            <searchLiveCourseEn v-else-if="type == 18"></searchLiveCourseEn>

            <!-- jonh live course -->
            <jonhLiveCourseEn v-else-if="type == 19"></jonhLiveCourseEn>

            <!-- Change Avatar -->
            <changeAvaManualEn v-else-if="type == 20"></changeAvaManualEn>

            <!-- Change Infor -->
            <changeInfoManualEn v-else-if="type == 21"></changeInfoManualEn>

            <!-- Change language system -->
            <changeLanguageSystemEn v-else-if="type == 22"></changeLanguageSystemEn>

            <!-- Change Pass -->
            <changePassManualEn v-else-if="type == 23"></changePassManualEn>

            <!-- Achievement Student -->
            <achievementStudentManualEn v-else-if="type == 24"></achievementStudentManualEn>

            <!-- Manage Student -->
            <manageStudentManualEn v-else-if="type == 25"></manageStudentManualEn>

            <!-- Manage Course -->
            <manageCourseManualEn v-else-if="type == 26"></manageCourseManualEn>

            <!-- Manage Attendance -->
            <manageAttendanceManualEn v-else-if="type == 27"></manageAttendanceManualEn>

            <!-- Manage Live Course -->
            <manageLiveCourseManualEn v-else-if="type == 28"></manageLiveCourseManualEn>
        </div>
        <!-- Japanese -->
        <div v-else-if="typeLanguage == 3">
            <!-- PC -->
            <usingPcJa v-if="type == 0"></usingPcJa>

            <!-- PWA -->
            <pwaManualJa v-if="type == 1"></pwaManualJa>

            <!-- Change Language -->
            <changeLanguageManualJa v-else-if="type == 2"></changeLanguageManualJa>

            <!-- Login -->
            <loginManualJa v-else-if="type == 3"></loginManualJa>

            <!-- Forgot Pass -->
            <forgotPassManualJa v-else-if="type == 4"></forgotPassManualJa>

            <!-- Logout -->
            <logoutJa v-else-if="type == 5"></logoutJa>

            <!-- Search Course -->
            <searchCourseManualJa v-else-if="type == 6"></searchCourseManualJa>

            <!-- My Course -->
            <myCourseManualJa v-else-if="type == 7"></myCourseManualJa>

            <!-- content lesson -->
            <lessonContentJa v-else-if="type == 8 && loadDataLessonContent" :data="data.data"></lessonContentJa>

            <!-- Mid Term -->
            <midTermManualJa v-else-if="type == 9"></midTermManualJa>

            <!-- Final Exam -->
            <finalExamManualJa v-else-if="type == 10"></finalExamManualJa>

            <!-- Achievement -->
            <achievementManualJa v-else-if="type == 11"></achievementManualJa>

            <!-- Covenant -->
            <covenantManualJa v-else-if="type == 12"></covenantManualJa>

            <!-- Survey -->
            <surveyManualJa v-else-if="type == 13"></surveyManualJa>

            <!-- Export Note -->
            <exportNoteManualJa v-else-if="type == 14"></exportNoteManualJa>

            <!-- End Course -->
            <endCourseManualJa v-else-if="type == 15"></endCourseManualJa>

            <!-- study Situation List -->
            <studySituationListJa v-else-if="type == 16"></studySituationListJa>

            <!-- course Score Statistics -->
            <scoreStatisticsJa v-else-if="type == 17"></scoreStatisticsJa>

            <!-- search live course -->
            <searchLiveCourseJa v-else-if="type == 18"></searchLiveCourseJa>

            <!-- jonh live course -->
            <jonhLiveCourseJa v-else-if="type == 19"></jonhLiveCourseJa>

            <!-- Change Avatar -->
            <changeAvaManualJa v-else-if="type == 20"></changeAvaManualJa>

            <!-- Change Infor -->
            <changeInfoManualJa v-else-if="type == 21"></changeInfoManualJa>

            <!-- Change language system -->
            <changeLanguageSystemJa v-else-if="type == 22"></changeLanguageSystemJa>

            <!-- Change Pass -->
            <changePassManualJa v-else-if="type == 23"></changePassManualJa>

            <!-- Achievement Student -->
            <achievementStudentManualJa v-else-if="type == 24"></achievementStudentManualJa>

            <!-- Manage Student -->
            <manageStudentManualJa v-else-if="type == 25"></manageStudentManualJa>

            <!-- Manage Course -->
            <manageCourseManualJa v-else-if="type == 26"></manageCourseManualJa>

            <!-- Manage Attendance -->
            <manageAttendanceManualJa v-else-if="type == 27"></manageAttendanceManualJa>

            <!-- Manage Live Course -->
            <manageLiveCourseManualJa v-else-if="type == 28"></manageLiveCourseManualJa>
        </div>
        <!-- Vietnamese -->
        <div v-if="typeLanguage == 4">
            <!-- PC -->
            <usingPcVi v-if="type == 0"></usingPcVi>

            <!-- PWA -->
            <pwaManualVi v-if="type == 1"></pwaManualVi>

            <!-- Change Language -->
            <changeLanguageManualVi v-else-if="type == 2"></changeLanguageManualVi>

            <!-- Login -->
            <loginManualVi v-else-if="type == 3"></loginManualVi>

            <!-- Forgot Pass -->
            <forgotPassManualVi v-else-if="type == 4"></forgotPassManualVi>

            <!-- Logout -->
            <logoutVi v-else-if="type == 5"></logoutVi>

            <!-- Search Course -->
            <searchCourseManualVi v-else-if="type == 6"></searchCourseManualVi>

            <!-- My Course -->
            <myCourseManualVi v-else-if="type == 7"></myCourseManualVi>

            <!-- content lesson -->
            <lessonContentVi v-else-if="type == 8 && loadDataLessonContent" :data="data.data"></lessonContentVi>

            <!-- Mid Term -->
            <midTermManualVi v-else-if="type == 9"></midTermManualVi>

            <!-- Final Exam -->
            <finalExamManualVi v-else-if="type == 10"></finalExamManualVi>

            <!-- Achievement -->
            <achievementManualVi v-else-if="type == 11"></achievementManualVi>

            <!-- Covenant -->
            <covenantManualVi v-else-if="type == 12"></covenantManualVi>

            <!-- Survey -->
            <surveyManualVi v-else-if="type == 13"></surveyManualVi>

            <!-- Export Note -->
            <exportNoteManualVi v-else-if="type == 14"></exportNoteManualVi>

            <!-- End Course -->
            <endCourseManualVi v-else-if="type == 15"></endCourseManualVi>

            <!-- study Situation List -->
            <studySituationListVi v-else-if="type == 16"></studySituationListVi>

            <!-- course Score Statistics -->
            <scoreStatisticsVi v-else-if="type == 17"></scoreStatisticsVi>

            <!-- search live course -->
            <searchLiveCourseVi v-else-if="type == 18"></searchLiveCourseVi>

            <!-- jonh live course -->
            <jonhLiveCourseVi v-else-if="type == 19"></jonhLiveCourseVi>

            <!-- Change Avatar -->
            <changeAvaManualVi v-else-if="type == 20"></changeAvaManualVi>

            <!-- Change Infor -->
            <changeInfoManualVi v-else-if="type == 21"></changeInfoManualVi>

            <!-- Change language system -->
            <changeLanguageSystemVi v-else-if="type == 22"></changeLanguageSystemVi>

            <!-- Change Pass -->
            <changePassManualVi v-else-if="type == 23"></changePassManualVi>

            <!-- Achievement Student -->
            <achievementStudentManualVi v-else-if="type == 24"></achievementStudentManualVi>

            <!-- Manage Student -->
            <manageStudentManualVi v-else-if="type == 25"></manageStudentManualVi>

            <!-- Manage Course -->
            <manageCourseManualVi v-else-if="type == 26"></manageCourseManualVi>

            <!-- Manage Attendance -->
            <manageAttendanceManualVi v-else-if="type == 27"></manageAttendanceManualVi>

            <!-- Manage Live Course -->
            <manageLiveCourseManualVi v-else-if="type == 28"></manageLiveCourseManualVi>
        </div>
    </div>
</template>

<script>
    import loginManualVi from "@/components/manual/content/vi/login_manual";
    import forgotPassManualVi from "@/components/manual/content/vi/forgotPass_manual";
    import changeLanguageManualVi from "@/components/manual/content/vi/changeLanguage_manual";
    import changeAvaManualVi from "@/components/manual/content/vi/changeAva_manual";
    import changeInfoManualVi from "@/components/manual/content/vi/changeInfo_manual";
    import changePassManualVi from "@/components/manual/content/vi/changePass_manual";
    import searchCourseManualVi from "@/components/manual/content/vi/searchCourse_manual";
    import myCourseManualVi from "@/components/manual/content/vi/myCourse_manual";
    import exportNoteManualVi from "@/components/manual/content/vi/exportNote_manual";
    import midTermManualVi from "@/components/manual/content/vi/midTerm_manual";
    import finalExamManualVi from "@/components/manual/content/vi/finalExam_manual";
    import achievementManualVi from "@/components/manual/content/vi/achievement_manual";
    import covenantManualVi from "@/components/manual/content/vi/covenant_manual";
    import surveyManualVi from "@/components/manual/content/vi/survey_manual";
    import endCourseManualVi from "@/components/manual/content/vi/endCourse_manual";
    import achievementStudentManualVi from "@/components/manual/content/vi/achievementStudent_manual";
    import manageStudentManualVi from "@/components/manual/content/vi/manageStudent_manual";
    import manageCourseManualVi from "@/components/manual/content/vi/manageCourse_manual";
    import manageAttendanceManualVi from "@/components/manual/content/vi/manageAttendance_manual";
    import manageLiveCourseManualVi from "@/components/manual/content/vi/manageLiveCourse_manual";
    import pwaManualVi from "@/components/manual/content/vi/pwa_manual";
    import studySituationListVi from "@/components/manual/content/vi/studySituationList_manual";
    import scoreStatisticsVi from "@/components/manual/content/vi/scoreStatistics_manual";
    import searchLiveCourseVi from "@/components/manual/content/vi/searchLiveCourse_manual";
    import jonhLiveCourseVi from "@/components/manual/content/vi/jonhLiveCourse_manual";
    import usingPcVi from "@/components/manual/content/vi/usingPc_manual";
    import logoutVi from "@/components/manual/content/vi/logout_manual";
    import changeLanguageSystemVi from "@/components/manual/content/vi/changeLanguageSystem_manual";
    import lessonContentVi from "@/components/manual/content/vi/lessonContent_manual";

    import loginManualJa from "@/components/manual/content/ja/login_manual";
    import forgotPassManualJa from "@/components/manual/content/ja/forgotPass_manual";
    import changeLanguageManualJa from "@/components/manual/content/ja/changeLanguage_manual";
    import changeAvaManualJa from "@/components/manual/content/ja/changeAva_manual";
    import changeInfoManualJa from "@/components/manual/content/ja/changeInfo_manual";
    import changePassManualJa from "@/components/manual/content/ja/changePass_manual";
    import searchCourseManualJa from "@/components/manual/content/ja/searchCourse_manual";
    import myCourseManualJa from "@/components/manual/content/ja/myCourse_manual";
    import exportNoteManualJa from "@/components/manual/content/ja/exportNote_manual";
    import midTermManualJa from "@/components/manual/content/ja/midTerm_manual";
    import finalExamManualJa from "@/components/manual/content/ja/finalExam_manual";
    import achievementManualJa from "@/components/manual/content/ja/achievement_manual";
    import covenantManualJa from "@/components/manual/content/ja/covenant_manual";
    import surveyManualJa from "@/components/manual/content/ja/survey_manual";
    import endCourseManualJa from "@/components/manual/content/ja/endCourse_manual";
    import achievementStudentManualJa from "@/components/manual/content/ja/achievementStudent_manual";
    import manageStudentManualJa from "@/components/manual/content/ja/manageStudent_manual";
    import manageCourseManualJa from "@/components/manual/content/ja/manageCourse_manual";
    import manageAttendanceManualJa from "@/components/manual/content/ja/manageAttendance_manual";
    import manageLiveCourseManualJa from "@/components/manual/content/ja/manageLiveCourse_manual";
    import pwaManualJa from "@/components/manual/content/ja/pwa_manual";
    import studySituationListJa from "@/components/manual/content/ja/studySituationList_manual";
    import scoreStatisticsJa from "@/components/manual/content/ja/scoreStatistics_manual";
    import searchLiveCourseJa from "@/components/manual/content/ja/searchLiveCourse_manual";
    import jonhLiveCourseJa from "@/components/manual/content/ja/jonhLiveCourse_manual";
    import usingPcJa from "@/components/manual/content/ja/usingPc_manual";
    import logoutJa from "@/components/manual/content/ja/logout_manual";
    import changeLanguageSystemJa from "@/components/manual/content/ja/changeLanguageSystem_manual";
    import lessonContentJa from "@/components/manual/content/ja/lessonContent_manual";

    import loginManualZh from "@/components/manual/content/zh/login_manual";
    import forgotPassManualZh from "@/components/manual/content/zh/forgotPass_manual";
    import changeLanguageManualZh from "@/components/manual/content/zh/changeLanguage_manual";
    import changeAvaManualZh from "@/components/manual/content/zh/changeAva_manual";
    import changeInfoManualZh from "@/components/manual/content/zh/changeInfo_manual";
    import changePassManualZh from "@/components/manual/content/zh/changePass_manual";
    import searchCourseManualZh from "@/components/manual/content/zh/searchCourse_manual";
    import myCourseManualZh from "@/components/manual/content/zh/myCourse_manual";
    import exportNoteManualZh from "@/components/manual/content/zh/exportNote_manual";
    import midTermManualZh from "@/components/manual/content/zh/midTerm_manual";
    import finalExamManualZh from "@/components/manual/content/zh/finalExam_manual";
    import achievementManualZh from "@/components/manual/content/zh/achievement_manual";
    import covenantManualZh from "@/components/manual/content/zh/covenant_manual";
    import surveyManualZh from "@/components/manual/content/zh/survey_manual";
    import endCourseManualZh from "@/components/manual/content/zh/endCourse_manual";
    import achievementStudentManualZh from "@/components/manual/content/zh/achievementStudent_manual";
    import manageStudentManualZh from "@/components/manual/content/zh/manageStudent_manual";
    import manageCourseManualZh from "@/components/manual/content/zh/manageCourse_manual";
    import manageAttendanceManualZh from "@/components/manual/content/zh/manageAttendance_manual";
    import manageLiveCourseManualZh from "@/components/manual/content/zh/manageLiveCourse_manual";
    import pwaManualZh from "@/components/manual/content/zh/pwa_manual";
    import studySituationListZh from "@/components/manual/content/zh/studySituationList_manual";
    import scoreStatisticsZh from "@/components/manual/content/zh/scoreStatistics_manual";
    import searchLiveCourseZh from "@/components/manual/content/zh/searchLiveCourse_manual";
    import jonhLiveCourseZh from "@/components/manual/content/zh/jonhLiveCourse_manual";
    import usingPcZh from "@/components/manual/content/zh/usingPc_manual";
    import logoutZh from "@/components/manual/content/zh/logout_manual";
    import changeLanguageSystemZh from "@/components/manual/content/zh/changeLanguageSystem_manual";
    import lessonContentZh from "@/components/manual/content/zh/lessonContent_manual";

    import loginManualEn from "@/components/manual/content/en/login_manual";
    import forgotPassManualEn from "@/components/manual/content/en/forgotPass_manual";
    import changeLanguageManualEn from "@/components/manual/content/en/changeLanguage_manual";
    import changeAvaManualEn from "@/components/manual/content/en/changeAva_manual";
    import changeInfoManualEn from "@/components/manual/content/en/changeInfo_manual";
    import changePassManualEn from "@/components/manual/content/en/changePass_manual";
    import searchCourseManualEn from "@/components/manual/content/en/searchCourse_manual";
    import myCourseManualEn from "@/components/manual/content/en/myCourse_manual";
    import exportNoteManualEn from "@/components/manual/content/en/exportNote_manual";
    import midTermManualEn from "@/components/manual/content/en/midTerm_manual";
    import finalExamManualEn from "@/components/manual/content/en/finalExam_manual";
    import achievementManualEn from "@/components/manual/content/en/achievement_manual";
    import covenantManualEn from "@/components/manual/content/en/covenant_manual";
    import surveyManualEn from "@/components/manual/content/en/survey_manual";
    import endCourseManualEn from "@/components/manual/content/en/endCourse_manual";
    import achievementStudentManualEn from "@/components/manual/content/en/achievementStudent_manual";
    import manageStudentManualEn from "@/components/manual/content/en/manageStudent_manual";
    import manageCourseManualEn from "@/components/manual/content/en/manageCourse_manual";
    import manageAttendanceManualEn from "@/components/manual/content/en/manageAttendance_manual";
    import manageLiveCourseManualEn from "@/components/manual/content/en/manageLiveCourse_manual";
    import pwaManualEn from "@/components/manual/content/en/pwa_manual";
    import studySituationListEn from "@/components/manual/content/en/studySituationList_manual";
    import scoreStatisticsEn from "@/components/manual/content/en/scoreStatistics_manual";
    import searchLiveCourseEn from "@/components/manual/content/en/searchLiveCourse_manual";
    import jonhLiveCourseEn from "@/components/manual/content/en/jonhLiveCourse_manual";
    import usingPcEn from "@/components/manual/content/en/usingPc_manual";
    import logoutEn from "@/components/manual/content/en/logout_manual";
    import changeLanguageSystemEn from "@/components/manual/content/en/changeLanguageSystem_manual";
    import lessonContentEn from "@/components/manual/content/en/lessonContent_manual";
    
    export default {
        data() {
            return {
                type: 0,
                typeLanguage: 3,
                loadDataLessonContent: true,
            };
        },
        components: {
            loginManualVi,
            forgotPassManualVi,
            changeLanguageManualVi,
            changeAvaManualVi,
            changeInfoManualVi,
            changePassManualVi,
            searchCourseManualVi,
            myCourseManualVi,
            exportNoteManualVi,
            midTermManualVi,
            finalExamManualVi,
            achievementManualVi,
            covenantManualVi,
            surveyManualVi,
            endCourseManualVi,
            achievementStudentManualVi,
            manageStudentManualVi,
            manageCourseManualVi,
            manageAttendanceManualVi,
            manageLiveCourseManualVi,
            pwaManualVi,
            studySituationListVi,
            scoreStatisticsVi,
            searchLiveCourseVi,
            jonhLiveCourseVi,
            usingPcVi,
            logoutVi,
            changeLanguageSystemVi,
            lessonContentVi,

            loginManualJa,
            forgotPassManualJa,
            changeLanguageManualJa,
            changeAvaManualJa,
            changeInfoManualJa,
            changePassManualJa,
            searchCourseManualJa,
            myCourseManualJa,
            exportNoteManualJa,
            midTermManualJa,
            finalExamManualJa,
            achievementManualJa,
            covenantManualJa,
            surveyManualJa,
            endCourseManualJa,
            achievementStudentManualJa,
            manageStudentManualJa,
            manageCourseManualJa,
            manageAttendanceManualJa,
            manageLiveCourseManualJa,
            pwaManualJa,
            studySituationListJa,
            scoreStatisticsJa,
            searchLiveCourseJa,
            jonhLiveCourseJa,
            usingPcJa,
            logoutJa,
            changeLanguageSystemJa,
            lessonContentJa,

            loginManualZh,
            forgotPassManualZh,
            changeLanguageManualZh,
            changeAvaManualZh,
            changeInfoManualZh,
            changePassManualZh,
            searchCourseManualZh,
            myCourseManualZh,
            exportNoteManualZh,
            midTermManualZh,
            finalExamManualZh,
            achievementManualZh,
            covenantManualZh,
            surveyManualZh,
            endCourseManualZh,
            achievementStudentManualZh,
            manageStudentManualZh,
            manageCourseManualZh,
            manageAttendanceManualZh,
            manageLiveCourseManualZh,
            pwaManualZh,
            studySituationListZh,
            scoreStatisticsZh,
            searchLiveCourseZh,
            jonhLiveCourseZh,
            usingPcZh,
            logoutZh,
            changeLanguageSystemZh,
            lessonContentZh,

            loginManualEn,
            forgotPassManualEn,
            changeLanguageManualEn,
            changeAvaManualEn,
            changeInfoManualEn,
            changePassManualEn,
            searchCourseManualEn,
            myCourseManualEn,
            exportNoteManualEn,
            midTermManualEn,
            finalExamManualEn,
            achievementManualEn,
            covenantManualEn,
            surveyManualEn,
            endCourseManualEn,
            achievementStudentManualEn,
            manageStudentManualEn,
            manageCourseManualEn,
            manageAttendanceManualEn,
            manageLiveCourseManualEn,
            pwaManualEn,
            studySituationListEn,
            scoreStatisticsEn,
            searchLiveCourseEn,
            jonhLiveCourseEn,
            usingPcEn,
            logoutEn,
            changeLanguageSystemEn,
            lessonContentEn
        },
        props: {
            data: {
                type: Object,
                default: {},
            },
        },
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {
            this.typeLanguage = this.$lang();
        },
        watch: {
            data(value) {
                if (
                    value.data.type==31
                    || value.data.type==32
                    || value.data.type==33
                    || value.data.type==34
                    || value.data.type==35
                    || value.data.type==36
                    || value.data.type==37
                    || value.data.type==38
                    || value.data.type==39
                    || value.data.type==40
                ){
                    this.type = 8;
                } else {
                    this.type = value.data.type;
                }
                this.loadDataLessonContent = false;
                this.$nextTick(() => {
                    this.loadDataLessonContent = true;
                });
            },
        },
        methods: {},
    };
</script>
<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/manual/content_manual.vue